import {useNavigationService} from '@/di/di.root-container.hooks';

import {PropsWithChildren, useEffect} from 'react';

import {useUserStore} from '@/stores/connectors';
import {LoaderPage} from '@/ui/pages/LoaderPage/LoaderPage';

export function AuthGuard({children}: PropsWithChildren<unknown>): JSX.Element {
  const userStore = useUserStore();
  const userState = userStore.getState();
  const navigationService = useNavigationService();

  useEffect(() => {
    if (userStore.isGuest() || userStore.isError()) {
      navigationService.navigateToAuthUserPage();
    }
  }, [userState, userStore]);

  if (userStore.isLoggedIn()) {
    return <>{children}</>;
  }

  return <LoaderPage />;
}
